import AppointmentConfirmation from 'surveys/insomnia_funnel/paywall/AppointmentConfirmation/AppointmentConfirmation';
import AppointmentManagement from 'surveys/insomnia_funnel/appointment/AppointmentManagement/AppointmentManagement';
import InsomniaSurvey from 'screens/InsomniaSurvey/InsomniaSurvey';
import insomniaSurveyConfig from 'surveys/insomnia_funnel/survey/insomnia_funnel';
import bookingSurveyConfig, {BOOKING_BASE_PATH} from 'surveys/insomnia_funnel/survey/insomnia_booking';
import InsomniaCheckout from 'surveys/insomnia_funnel/paywall/InsomniaCheckout';

export const useSurveyConfig = () => {
  return insomniaSurveyConfig;
};

export const InsomniaSurveyScreenContainer = () => {
  const surveyConfig = useSurveyConfig();
  return <InsomniaSurvey surveyConfigJson={surveyConfig} />;
};

export const InsomniaCheckoutScreenContainer = () => {
  return <InsomniaCheckout variantName="checkout_insomnia_checkout" />;
};

export const AppointmentConfirmationScreenContainer = () => {
  return <AppointmentConfirmation />;
};

export const AppointmentManagementScreenContainer = () => {
  return <AppointmentManagement />;
};

// Appointment-booking funnel, mounted under /book-appointment.
export const BookingSurveyScreenContainer = () => {
  return <InsomniaSurvey surveyConfigJson={bookingSurveyConfig} />;
};

export const BookingCheckoutScreenContainer = () => {
  return <InsomniaCheckout variantName="checkout_booking_checkout" basePath={BOOKING_BASE_PATH} />;
};
